import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8717e8c2&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./style/transfer.scss?vue&type=style&index=0&id=8717e8c2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8717e8c2",
  null
  
)

export default component.exports